<template>
        <div class='relative'>
            <span class='iconIpt ilbk absolute'>
                <img src="../../assets/imgs/pwd.png" alt="">
            </span>
            <input @blur="scrollInto" class='inputStyle' v-model='pwd' type="password" name="" :placeholder=placeholder />
        </div>
</template>
<script>
    import {pwdReg} from '@/utils/regular.js'
export default {
    data(){
        return {
           pwd:'',
        }
    },
    props: {
        verify:{ // 是否验证失败
            type: Boolean,
            default() { return false; }
        },
        com_id:{ // 组件唯一id，同一页面多次引用此组件时进行区分
            type: String,
            default() { return ''; }
        },
        placeholder:{ // placeholder 文字
            type: String,
            default() { return ''; }
        },
    },
    watch:{
        pwd(val){
            val = val.trim();
            let pwdFlag;
            pwdFlag = pwdReg.test(val)
            this.$emit('pwdEmit',{
                name:val,
                pwdFlag:pwdFlag,
                com_id:this.com_id
            })
        },
        verify(val){
            this.verify = val
        }
    },
    methods:{
        cleanInfo(){
            this.applicantName = '' 
        },
        scrollInto(){
            window.setTimeout(function () {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop ;
                if(scrollHeight){
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }
            }, 0);            
        }
    }
}
</script>
<style lang="less" scoped>
</style>